var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showNBHeader)?_c('net-benefits-header',{attrs:{"title":_vm.accountType}}):_c('pvd-header',{attrs:{"title":_vm.accountType,"hide-login":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }